function newId(prefix) {
  return `${prefix}_${Date.now()}_${Math.floor(Math.random() * 1000)}`;
}

export function createMenuItem(partial = {}) {
  return {
    id: newId("item"),
    label: "",
    link: "",
    ...partial,
    items: Array.isArray(partial.items) ? partial.items : [],
  };
}

const DEFAULT_HEADER_MENU = [
  { id: "menu_home", label: "Home", link: "/", items: [] },
  { id: "menu_collections", label: "Collections", link: "/collection", items: [] },
  { id: "menu_track", label: "Track Order", link: "/track-order", items: [] },
  { id: "menu_about", label: "About", link: "/about", items: [] },
  { id: "menu_contact", label: "Contact", link: "/contact", items: [] },
];

export function defaultHeaderMenu() {
  return DEFAULT_HEADER_MENU.map((entry) => ({ ...entry, items: [] }));
}

function normalizeEntry(entry) {
  const items = Array.isArray(entry?.items) ? entry.items.map(normalizeEntry) : [];
  return {
    id: entry?.id || newId("item"),
    label: entry?.label || entry?.name || "",
    link: typeof entry?.link === "string" ? entry.link : "",
    items,
  };
}

export function resolveHeaderMenu(settings) {
  if (!Array.isArray(settings?.headerMenus)) return defaultHeaderMenu();
  return settings.headerMenus.map(normalizeEntry);
}

export function visibleHeaderMenu(settings) {
  return resolveHeaderMenu(settings)
    .map(visibleEntry)
    .filter(Boolean);
}

function visibleEntry(entry) {
  if (!entry?.label || !String(entry.label).trim()) return null;
  return {
    ...entry,
    items: (entry.items || []).map(visibleEntry).filter(Boolean),
  };
}

export function menuChildren(entry) {
  return (entry?.items || []).filter((item) => item?.label && String(item.label).trim());
}

export function isExternalLink(link) {
  const value = String(link || "").trim();
  if (!value) return false;
  if (/^(https?:\/\/|mailto:|tel:)/i.test(value)) return true;
  if (/^www\./i.test(value)) return true;
  return /^[a-z0-9-]+(\.[a-z0-9-]+)+([:/?#].*)?$/i.test(value);
}

export function normalizeMenuLink(link) {
  const value = String(link || "").trim();
  if (!value) return "";
  if (/^(https?:\/\/|mailto:|tel:)/i.test(value) || value.startsWith("/") || value.startsWith("#")) {
    return value;
  }
  if (/^www\./i.test(value) || /^[a-z0-9-]+(\.[a-z0-9-]+)+([:/?#].*)?$/i.test(value)) {
    return `https://${value}`;
  }
  return `/${value.replace(/^\/+/, "")}`;
}

export function menuLinkIsActive(link, pathname) {
  const path = normalizeMenuLink(link);
  if (!path || isExternalLink(path) || path.startsWith("#")) return false;
  if (path === "/") return pathname === "/";
  return pathname === path || pathname.startsWith(`${path}/`);
}

export function menuBranchIsActive(entry, pathname) {
  if (menuLinkIsActive(entry?.link, pathname)) return true;
  return (entry?.items || []).some((item) => menuBranchIsActive(item, pathname));
}
